<div *ngIf="industryList | async as industries">
<h2 *ngIf="industries.length > 0" class="pt-4">Industries</h2>
  <div class="marquee">
    <div class="marquee__inner">
      <div *ngFor="let industry of industries">
        <img class="industry-logo m-3" [alt]="industry" [src]="'assets/images/industries/' + industry"/>
      </div>
      <div *ngFor="let industry of industries">
        <img class="industry-logo m-3" [alt]="industry" [src]="'assets/images/industries/' + industry"/>
      </div>
    </div>
  </div>
</div>
